// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import less from 'less'
import '@/style/reset.css'
import '@/style/public.css'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import * as api from './axios/api'
import common from './axios/common'
import VideoPlayer from 'vue-video-player'
Vue.use(less)
Vue.use(ElementUI)
Vue.use(VideoPlayer)
Vue.prototype.$api = api
Vue.prototype.$store = store
Vue.prototype.common = common
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App,
    store
  },
  template: '<App/>'
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
});



// WEBPACK FOOTER //
// ./src/main.js